import React from "react";
import { Button, useTheme } from "@mui/material";
import { ArrowRight } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const V2_PREFIX = "/v2";
const CORPORATE_DETAIL_PATTERN =
  /^\/(?:v2\/)?corporate\/([^/]+)\/detail(?:\/(.*))?$/;

const CATALOG_SECTIONS = ["activities", "courses", "paths"];

export const getV1PathFromV2 = (pathname: string): string | null => {
  if (!pathname.startsWith(V2_PREFIX)) return null;
  const match = pathname.match(CORPORATE_DETAIL_PATTERN);
  if (!match) return null;

  const corporateId = match[1];
  const segments = (match[2] ?? "").split("/").filter(Boolean);
  const isCatalog = segments[0] === "catalog";
  const section = CATALOG_SECTIONS.includes(segments[1] ?? "")
    ? segments[1]
    : null;

  const v1Base = `/corporate/${corporateId}/detail`;
  if (!isCatalog) return v1Base;
  return section ? `${v1Base}/catalog/${section}` : `${v1Base}/catalog`;
};

const V2ToggleCst: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation("header");

  const isV2 = location.pathname.startsWith(V2_PREFIX);
  const match = location.pathname.match(CORPORATE_DETAIL_PATTERN);

  if (!match || isV2) return null;

  const corporateId = match[1];

  return (
    <Button
      onClick={() =>
        navigate(`${V2_PREFIX}/corporate/${corporateId}/detail/my-space`)
      }
      endIcon={<ArrowRight size={18} />}
      sx={{
        textTransform: "none",
        fontWeight: 700,
        fontSize: "14px",
        borderRadius: "8px",
        padding: "6px 18px",
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: `2px solid ${theme.palette.text.primary}`,
        whiteSpace: "nowrap",
        flexShrink: 0,
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
          borderColor: theme.palette.text.primary,
        },
      }}
    >
      {t("v2-toggle.go-new")}
    </Button>
  );
};

export default V2ToggleCst;
